import { calculateRating } from '@helpers/rating';
import React from 'react';

type RatingNumberProps = {
  rating: number;
  size?: 'sm' | 'md' | 'lg' | 'xsm';
};

const sizeClass = {
  xsm: 'h-7 text-sm w-7',
  sm: 'h-7 text-15 w-7',
  md: 'h-8 text-15 w-8',
  lg: 'h-10 text-18.75 w-10',
};

function RatingNumber({ rating, size }: RatingNumberProps) {
  return (
    <div
      data-testid="rating-number"
      className={`
      ${
        size ? sizeClass[size] : ''
      } bg-rp-light-gray-5 flex flex-shrink-0 font-medium items-center justify-center px-1.5 py-2 rounded-md text-custom-black -tracking-0.02em`}
    >
      {calculateRating(rating)}
    </div>
  );
}

RatingNumber.defaultProps = {
  size: 'md',
};

export default RatingNumber;
